import { cn } from '@lib/cn'
import React, { FC } from 'react'
import { Text, TextProps } from '../Typography/Text'

export const NotificationLabel: FC<TextProps> = ({ className, ...props }) => {
  return (
    <Text
      className={cn('mb-0 block w-full overflow-hidden text-ellipsis whitespace-nowrap', className)}
      {...props}
    />
  )
}
